<script lang="ts" setup>
import { computed } from "vue";
import { useRouter, useRoute } from "vue-router";

// Load application fonts
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "@wegift/company-brand-assets/dist/design-system/css/font-f37Lineca.css";

// App global styles
import "@two-ui/styles/global.sass";
import "@two-ui/styles/extensions.sass";
import "@two-ui/styles/type.sass";
import "@wegift/two-components/dist/style.css";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

const router = useRouter();
const route = useRoute();

// Controls whether the 'chrome' (sidebar and other bits) are shown.
// We disable them for pre-auth state as they need auth to function.
// We disable them for some routes for a 'full screen' view
// We disable them when route is not resolved
const isSidebarHiddenForRoute = computed(() => {
  const routeResolved = route.matched.length > 0;
  return !routeResolved || route.meta.preAuth || route.meta.hideSidebar;
});
</script>

<template>
  <router-view />
</template>
